/** Facts for the BI Denmark → BI Australia case story. Source: Boehringer T2D/CVD Snak report, 6 May 2025. */

export const nordicCampaign = {
  period: '31 March – 6 May 2025',
  market: 'Boehringer Ingelheim Denmark',
  audience: 'GPs and nurses',
}

export const nordicAudiences = {
  target: { label: 'Target HCPs', recipients: '~975', value: 975 },
  nonTarget: { label: 'Non-Target HCPs', recipients: '1,188', value: 1188 },
}

/** Non-Target event results — the hero story. */
export const nonTargetFunnel = [
  { value: '1,188', label: 'Emails distributed', detail: 'Non-Target HCPs who received the email' },
  { value: '132', label: 'Page views', detail: 'Times the Snak page was opened' },
  { value: '60', label: 'Snak™ views', detail: 'Times the Snak was played' },
  { value: '51', label: 'Unique Snak™ viewers', detail: 'Individual users, by device' },
]

export const nonTargetHeadlines = {
  avgViewTime: '3m 31s',
  ctr: '15%',
  cueClicks: '97',
}

export const targetComparison = {
  avgViewTime: '57s',
  ctr: '6%',
}

export const nordicInsights = [
  {
    figure: 'Almost half',
    statement: 'of participating GPs and nurses were not aware of the issue.',
    proof: '47% answered the clinical quiz question incorrectly.',
  },
  {
    figure: '83%',
    statement: 'of users expressing a resource preference were most interested in the KiAP website.',
    proof: 'Chosen from the Snak’s “Want to know more?” menu.',
  },
]
